"use strict";
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = _default;

var _UrlPathParams = require("settings-ui-sdk/constants/UrlPathParams");

function _default(url) {
  var tokens = url.split('/');
  var webPagesIndex = tokens.indexOf(_UrlPathParams.CONTENT_MEMBERSHIP);

  if (webPagesIndex !== -1 && tokens.length > webPagesIndex) {
    return tokens[webPagesIndex + 1];
  }

  return null;
}

module.exports = exports.default;